import { useState, useEffect } from 'react'
import { FiPlus, FiTrash2, FiUpload, FiDatabase, FiEdit2, FiDownloadCloud, FiChevronDown, FiChevronRight, FiHash, FiType, FiCalendar, FiToggleLeft, FiCheck, FiEye, FiEyeOff, FiX, FiCode, FiColumns, FiSearch } from 'react-icons/fi'
import toast from 'react-hot-toast'
import api from '../utils/api'

const DS_TYPES = [
  { value: 'postgresql', label: 'PostgreSQL', color: '#336791' },
  { value: 'mysql', label: 'MySQL', color: '#4479A1' },
  { value: 'firebird', label: 'Firebird', color: '#F37021' },
  { value: 'csv', label: 'CSV Dosyasi', color: '#10b981' },
]
const TYPE_ICONS = { number: FiHash, text: FiType, date: FiCalendar, boolean: FiToggleLeft }
const TYPE_COLORS = { number: 'text-blue-500', text: 'text-gray-400', date: 'text-purple-500', boolean: 'text-green-500' }

// SQL ifade oluşturucu operatörler ve fonksiyonlar
const OPERATORS = [
  { label: '+', value: ' + ', desc: 'Toplama' },
  { label: '-', value: ' - ', desc: 'Cikarma' },
  { label: '*', value: ' * ', desc: 'Carpma' },
  { label: '/', value: ' / ', desc: 'Bolme' },
  { label: '||', value: ' || ', desc: 'Metin Birlestir' },
  { label: '=', value: ' = ', desc: 'Esit' },
  { label: '!=', value: ' <> ', desc: 'Esit Degil' },
  { label: '>', value: ' > ', desc: 'Buyuk' },
  { label: '<', value: ' < ', desc: 'Kucuk' },
  { label: 'AND', value: ' AND ', desc: 'VE' },
  { label: 'OR', value: ' OR ', desc: 'VEYA' },
]
const SQL_FUNCTIONS = [
  { label: 'UPPER()', value: 'UPPER()', desc: 'Buyuk harfe cevir' },
  { label: 'LOWER()', value: 'LOWER()', desc: 'Kucuk harfe cevir' },
  { label: 'TRIM()', value: 'TRIM()', desc: 'Bosluk temizle' },
  { label: 'COALESCE(,\'\')', value: "COALESCE(, '')", desc: 'Bos ise varsayilan' },
  { label: 'CAST(.. AS INTEGER)', value: 'CAST( AS INTEGER)', desc: 'Tip donustur' },
  { label: 'CASE WHEN..THEN..END', value: "CASE WHEN  THEN  ELSE  END", desc: 'Kosullu deger' },
  { label: 'SUBSTRING(,1,5)', value: 'SUBSTRING( FROM 1 FOR 5)', desc: 'Metin kes' },
  { label: 'CHAR_LENGTH()', value: 'CHAR_LENGTH()', desc: 'Metin uzunlugu' },
  { label: 'EXTRACT(YEAR FROM)', value: 'EXTRACT(YEAR FROM )', desc: 'Yil cikar' },
  { label: 'EXTRACT(MONTH FROM)', value: 'EXTRACT(MONTH FROM )', desc: 'Ay cikar' },
]

export default function DataSources() {
  const [sources, setSources] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [editingSource, setEditingSource] = useState(null)
  const [form, setForm] = useState({ name: '', ds_type: 'firebird', host: '', port: '', database: '', username: '', password: '' })

  const [selectedDs, setSelectedDs] = useState(null)
  const [schema, setSchema] = useState(null)
  const [expandedTables, setExpandedTables] = useState({})
  const [editingCol, setEditingCol] = useState(null)
  const [editingTable, setEditingTable] = useState(null)
  const [tableSearch, setTableSearch] = useState('')

  // Tablo veri onizlemesi
  const [previewTable, setPreviewTable] = useState(null) // { name, data, columns }
  const [previewLoading, setPreviewLoading] = useState(false)

  // Kolon ekleme
  const [showAddColumn, setShowAddColumn] = useState(null) // table object
  const [newColName, setNewColName] = useState('')
  const [newColExpr, setNewColExpr] = useState('')
  const [exprPreview, setExprPreview] = useState(null)

  useEffect(() => { loadSources() }, [])

  const loadSources = async () => {
    try { const { data } = await api.get('/datasources'); setSources(data) } catch (e) { toast.error('Yuklenemedi') }
  }
  const createSource = async (e) => {
    e.preventDefault()
    try {
      const payload = { ...form }; if (payload.port) payload.port = parseInt(payload.port)
      const { data } = await api.post('/datasources', payload)
      toast.success('Veri kaynagi eklendi')
      setShowForm(false); setForm({ name: '', ds_type: 'firebird', host: '', port: '', database: '', username: '', password: '' })
      loadSources()
      try { importSchema(data.id) } catch (e) {}
    } catch (err) { toast.error('Ekleme basarisiz: ' + (err.response?.data?.detail || err.message)) }
  }
  const updateSource = async (e) => {
    e.preventDefault()
    try {
      const payload = { ...form }; if (payload.port) payload.port = parseInt(payload.port)
      const { data } = await api.put(`/datasources/${editingSource.id}`, payload)
      toast.success(data?.message || 'Guncellendi', { duration: 6000 }); setShowForm(false); setEditingSource(null); loadSources()
    } catch (err) { toast.error('Basarisiz') }
  }
  const openEdit = (s) => {
    setEditingSource(s); setForm({ name: s.name, ds_type: s.ds_type, host: s.host || '', port: s.port || '', database: s.database || '', username: s.username || '', password: s.password || '' }); setShowForm(true)
  }
  const testConnection = async (id) => {
    try { const { data } = await api.post(`/datasources/${id}/test`); data.success ? toast.success('Baglanti basarili!') : toast.error('Basarisiz: ' + (data.error || '')) } catch (e) { toast.error('Test basarisiz') }
  }
  const importSchema = async (id) => {
    try {
      toast.loading('Tablolar cekiliyor...', { id: 'import' })
      const { data } = await api.post(`/datasources/${id}/import-schema`)
      toast.success(`${data.table_count} tablo, ${data.imported_columns} sutun`, { id: 'import' })
      loadSources(); loadSchema(id)
    } catch (err) { toast.error('Schema import basarisiz: ' + (err.response?.data?.detail || ''), { id: 'import' }) }
  }
  const loadSchema = async (id) => {
    try { const { data } = await api.get(`/datasources/${id}/schema`); setSchema(data); setSelectedDs(id) } catch (e) { toast.error('Yuklenemedi') }
  }
  const deleteSource = async (id) => {
    if (!confirm('Silinecek!')) return
    try { await api.delete(`/datasources/${id}`); toast.success('Silindi'); loadSources(); if (selectedDs === id) { setSelectedDs(null); setSchema(null) } } catch (e) { toast.error('Silinemedi') }
  }
  const toggleTable = (tid) => setExpandedTables(prev => ({ ...prev, [tid]: !prev[tid] }))
  const saveTableName = async (table) => {
    try { await api.put(`/datasources/schema/tables/${table.id}`, { display_name: editingTable.display_name }); toast.success('Guncellendi'); setEditingTable(null); loadSchema(selectedDs) } catch (e) { toast.error('Hata') }
  }
  const saveColumnEdit = async (col) => {
    try { await api.put(`/datasources/schema/columns/${col.id}`, editingCol); toast.success('Guncellendi'); setEditingCol(null); loadSchema(selectedDs) } catch (e) { toast.error('Hata') }
  }
  const toggleColumnVisible = async (col) => {
    try { await api.put(`/datasources/schema/columns/${col.id}`, { is_visible: !col.is_visible }); loadSchema(selectedDs) } catch (e) {}
  }

  // Tablo veri onizlemesi
  const loadPreview = async (tableName) => {
    if (previewTable?.name === tableName) { setPreviewTable(null); return } // toggle
    setPreviewLoading(true)
    try {
      const { data } = await api.get(`/datasources/${selectedDs}/table-data/${tableName}`, { params: { limit: 50 } })
      setPreviewTable({ name: tableName, data: data.data, columns: data.columns })
    } catch (err) { toast.error('Veri yuklenemedi: ' + (err.response?.data?.detail || '')) }
    setPreviewLoading(false)
  }

  // Hesaplanmis kolon onizleme
  const previewExpression = async () => {
    if (!newColExpr.trim() || !showAddColumn) return
    try {
      const ds = sources.find(s => s.id === selectedDs)
      const sql = ds?.ds_type === 'firebird'
        ? `SELECT FIRST 5 ${newColExpr} AS SONUC FROM ${showAddColumn.name}`
        : `SELECT ${newColExpr} AS SONUC FROM ${showAddColumn.name} LIMIT 5`
      const { data } = await api.post('/queries/execute', { datasource_id: selectedDs, sql_text: sql, limit: 5 })
      setExprPreview(data.data)
    } catch (err) { toast.error('Ifade hatasi: ' + (err.response?.data?.detail || '')); setExprPreview(null) }
  }

  // Ifadeye metin ekle
  const insertToExpr = (text) => setNewColExpr(prev => prev + text)

  const filteredTables = schema?.tables?.filter(t =>
    t.name.toLowerCase().includes(tableSearch.toLowerCase()) ||
    (t.display_name || '').toLowerCase().includes(tableSearch.toLowerCase())
  ) || []

  return (
    <div className="h-full flex">
      {/* Sol — Veri Kaynaklari */}
      <div className="w-72 bg-white border-r flex flex-col flex-shrink-0">
        <div className="p-4 border-b">
          <h2 className="font-semibold text-gray-800 text-sm">Veri Kaynaklari</h2>
        </div>
        <div className="flex-1 overflow-y-auto p-3 space-y-2">
          {sources.map((s) => {
            const dsType = DS_TYPES.find(t => t.value === s.ds_type)
            return (
              <div key={s.id} className={`rounded-xl border p-3 cursor-pointer transition-all ${selectedDs === s.id ? 'border-primary-300 bg-primary-50/50' : 'border-gray-100 hover:border-gray-200'}`}
                onClick={() => loadSchema(s.id)}>
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ backgroundColor: dsType?.color + '15' }}>
                    <FiDatabase size={13} style={{ color: dsType?.color }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium text-xs text-gray-800 truncate">{s.name}</h3>
                    <p className="text-[10px] text-gray-400">{dsType?.label} {s.table_count > 0 ? `· ${s.table_count} tablo` : ''}</p>
                  </div>
                </div>
                <div className="flex gap-1 mt-2">
                  <button onClick={(e) => { e.stopPropagation(); testConnection(s.id) }} className="text-[10px] px-1.5 py-0.5 bg-blue-50 text-blue-600 rounded hover:bg-blue-100">Test</button>
                  <button onClick={(e) => { e.stopPropagation(); importSchema(s.id) }} className="text-[10px] px-1.5 py-0.5 bg-green-50 text-green-600 rounded hover:bg-green-100">Semayi Al</button>
                  <button onClick={(e) => { e.stopPropagation(); openEdit(s) }} className="text-[10px] px-1.5 py-0.5 bg-gray-50 text-gray-500 rounded hover:bg-gray-100 ml-auto"><FiEdit2 size={10} /></button>
                  <button onClick={(e) => { e.stopPropagation(); deleteSource(s.id) }} className="text-[10px] px-1.5 py-0.5 bg-gray-50 text-red-400 rounded hover:bg-red-50"><FiTrash2 size={10} /></button>
                </div>
              </div>
            )
          })}
        </div>
        <div className="p-3 border-t space-y-1.5">
          <button onClick={() => { setEditingSource(null); setForm({ name: '', ds_type: 'firebird', host: '', port: '', database: '', username: '', password: '' }); setShowForm(true) }}
            className="w-full flex items-center justify-center gap-1 text-xs text-primary-600 py-2 border border-dashed border-primary-300 rounded-lg hover:bg-primary-50">
            <FiPlus size={12} /> Yeni Baglanti
          </button>
          <label className="w-full flex items-center justify-center gap-1 text-xs text-green-600 py-2 border border-dashed border-green-300 rounded-lg hover:bg-green-50 cursor-pointer">
            <FiUpload size={12} /> CSV Yukle
            <input type="file" accept=".csv" onChange={(e) => {
              const file = e.target.files[0]; if (!file) return
              const fd = new FormData(); fd.append('file', file)
              api.post('/datasources/upload-csv', fd).then(() => { toast.success('Yuklendi'); loadSources() }).catch(() => toast.error('Basarisiz'))
            }} className="hidden" />
          </label>
        </div>
      </div>

      {/* Sag — Schema + Onizleme */}
      <div className="flex-1 bg-gray-50 flex flex-col overflow-hidden">
        {schema ? (
          <>
            {/* Ust bar */}
            <div className="bg-white border-b px-5 py-3 flex items-center justify-between flex-shrink-0">
              <div>
                <h2 className="text-base font-semibold text-gray-800">{schema.datasource_name}</h2>
                <p className="text-[11px] text-gray-400">{schema.tables.length} tablo · Tabloya tikla = veri onizleme</p>
              </div>
              <div className="flex items-center gap-2">
                <div className="relative">
                  <FiSearch size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-300" />
                  <input value={tableSearch} onChange={(e) => setTableSearch(e.target.value)} placeholder="Tablo ara..."
                    className="pl-7 pr-3 py-1.5 text-xs border rounded-lg w-48 focus:ring-1 focus:ring-primary-500 outline-none" />
                </div>
                <button onClick={() => importSchema(selectedDs)} className="text-xs px-3 py-1.5 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-1">
                  <FiDownloadCloud size={12} /> Yenile
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-4">
              <div className="space-y-2">
                {filteredTables.map((table) => {
                  const isExpanded = expandedTables[table.id]
                  const isPreview = previewTable?.name === table.name
                  return (
                    <div key={table.id} className="bg-white rounded-xl border overflow-hidden">
                      {/* Tablo baslik */}
                      <div className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-50" onClick={() => toggleTable(table.id)}>
                        {isExpanded ? <FiChevronDown size={14} className="text-gray-400" /> : <FiChevronRight size={14} className="text-gray-400" />}
                        <FiDatabase size={13} className="text-primary-500" />
                        {editingTable?.id === table.id ? (
                          <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
                            <input value={editingTable.display_name} onChange={(e) => setEditingTable({ ...editingTable, display_name: e.target.value })}
                              className="text-sm font-medium border rounded px-1.5 py-0.5 w-48" autoFocus />
                            <button onClick={() => saveTableName(table)} className="text-green-600 p-0.5"><FiCheck size={14} /></button>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2 flex-1 min-w-0">
                            <span className="text-sm font-medium text-gray-800">{table.display_name}</span>
                            {table.display_name !== table.name && <span className="text-[10px] text-gray-300">{table.name}</span>}
                          </div>
                        )}
                        <span className="text-[10px] text-gray-400">{table.columns.length} alan</span>
                        <button onClick={(e) => { e.stopPropagation(); loadPreview(table.name) }}
                          className={`text-[10px] px-2 py-0.5 rounded ${isPreview ? 'bg-primary-100 text-primary-700' : 'bg-gray-50 text-gray-500 hover:bg-gray-100'}`}>
                          <FiEye size={10} className="inline mr-0.5" />{isPreview ? 'Kapat' : 'Onizle'}
                        </button>
                        <button onClick={(e) => { e.stopPropagation(); setShowAddColumn(table); setNewColName(''); setNewColExpr(''); setExprPreview(null) }}
                          className="text-[10px] px-2 py-0.5 bg-green-50 text-green-600 rounded hover:bg-green-100">
                          <FiPlus size={10} className="inline mr-0.5" />Kolon Ekle
                        </button>
                        <button onClick={(e) => { e.stopPropagation(); setEditingTable({ id: table.id, display_name: table.display_name }) }}
                          className="p-1 text-gray-300 hover:text-primary-600"><FiEdit2 size={12} /></button>
                      </div>

                      {/* Sutunlar */}
                      {isExpanded && (
                        <div className="border-t max-h-64 overflow-y-auto">
                          {table.columns.map((col) => {
                            const TypeIcon = TYPE_ICONS[col.col_type] || FiType
                            const typeColor = TYPE_COLORS[col.col_type] || 'text-gray-400'
                            const isEditingThis = editingCol?.id === col.id
                            return (
                              <div key={col.id} className="flex items-center gap-2 px-4 py-1 hover:bg-blue-50/50 border-b border-gray-50 last:border-0 group text-xs">
                                <TypeIcon size={11} className={typeColor} />
                                {isEditingThis ? (
                                  <div className="flex items-center gap-1 flex-1" onClick={(e) => e.stopPropagation()}>
                                    <input value={editingCol.display_name} onChange={(e) => setEditingCol({ ...editingCol, display_name: e.target.value })}
                                      className="border rounded px-1.5 py-0.5 w-28 text-xs" />
                                    <select value={editingCol.col_type} onChange={(e) => setEditingCol({ ...editingCol, col_type: e.target.value })}
                                      className="border rounded px-1 py-0.5 text-xs">
                                      <option value="text">Metin</option><option value="number">Sayi</option><option value="date">Tarih</option><option value="boolean">E/H</option>
                                    </select>
                                    <label className="flex items-center gap-0.5 text-[10px]">
                                      <input type="checkbox" checked={editingCol.is_measure} onChange={(e) => setEditingCol({ ...editingCol, is_measure: e.target.checked })} /> Olcu
                                    </label>
                                    <button onClick={() => saveColumnEdit(col)} className="text-green-600"><FiCheck size={12} /></button>
                                    <button onClick={() => setEditingCol(null)} className="text-gray-400"><FiX size={12} /></button>
                                  </div>
                                ) : (
                                  <>
                                    <span className="text-gray-700 flex-1 truncate">{col.display_name}{col.display_name !== col.name && <span className="text-gray-300 ml-1 text-[10px]">{col.name}</span>}</span>
                                    <span className={`text-[10px] px-1 rounded ${col.is_measure ? 'bg-blue-50 text-blue-500' : 'bg-gray-50 text-gray-400'}`}>{col.is_measure ? 'Olcu' : 'Boyut'}</span>
                                    <span className="text-[10px] text-gray-300">{col.col_type}</span>
                                    <div className="hidden group-hover:flex items-center">
                                      <button onClick={() => setEditingCol({ id: col.id, display_name: col.display_name, col_type: col.col_type, is_measure: col.is_measure })}
                                        className="p-0.5 text-gray-300 hover:text-primary-600"><FiEdit2 size={10} /></button>
                                      <button onClick={() => toggleColumnVisible(col)} className="p-0.5 text-gray-300 hover:text-gray-600">
                                        {col.is_visible ? <FiEye size={10} /> : <FiEyeOff size={10} />}
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            )
                          })}
                        </div>
                      )}

                      {/* Veri Onizleme */}
                      {isPreview && previewTable && (
                        <div className="border-t bg-gray-50/50">
                          <div className="overflow-auto max-h-80">
                            {previewLoading ? (
                              <div className="flex items-center justify-center py-8"><div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary-600" /></div>
                            ) : (
                              <table className="w-full text-xs">
                                <thead className="sticky top-0">
                                  <tr>{previewTable.columns.map(c => (
                                    <th key={c} className="bg-gray-100 text-left px-2 py-1.5 text-[10px] font-medium text-gray-500 border-b whitespace-nowrap">{c}</th>
                                  ))}</tr>
                                </thead>
                                <tbody>
                                  {previewTable.data.map((row, i) => (
                                    <tr key={i} className="hover:bg-blue-50/50 border-b border-gray-100">
                                      {previewTable.columns.map(c => (
                                        <td key={c} className="px-2 py-1 text-gray-600 whitespace-nowrap max-w-[200px] truncate">{row[c] ?? '-'}</td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                          <div className="px-3 py-1 text-[10px] text-gray-400 border-t">{previewTable.data.length} satir gosteriliyor</div>
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        ) : (
          <div className="flex items-center justify-center h-full text-gray-300">
            <div className="text-center">
              <FiDatabase size={40} className="mx-auto mb-3" />
              <p className="text-sm">Bir veri kaynagi secin</p>
            </div>
          </div>
        )}
      </div>

      {/* Kolon Ekleme Modal */}
      {showAddColumn && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowAddColumn(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[85vh] flex flex-col">
            <div className="px-5 py-3 border-b flex items-center justify-between">
              <div>
                <h2 className="text-base font-semibold">Hesaplanmis Kolon Ekle</h2>
                <p className="text-xs text-gray-400">Tablo: {showAddColumn.display_name || showAddColumn.name}</p>
              </div>
              <button onClick={() => setShowAddColumn(null)} className="p-1 hover:bg-gray-100 rounded"><FiX size={16} /></button>
            </div>

            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {/* Kolon adi */}
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Kolon Adi</label>
                <input value={newColName} onChange={(e) => setNewColName(e.target.value)}
                  placeholder="ornek: TAM_AD" className="w-full px-3 py-2 border rounded-lg text-sm" />
              </div>

              {/* Mevcut kolonlar — tikla ekle */}
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Mevcut Kolonlar <span className="text-gray-400">(tikla = ifadeye ekle)</span></label>
                <div className="flex flex-wrap gap-1 max-h-24 overflow-y-auto p-2 bg-gray-50 rounded-lg border">
                  {showAddColumn.columns.map(c => (
                    <button key={c.id} onClick={() => insertToExpr(c.name)}
                      className="text-[11px] px-2 py-0.5 bg-white border rounded hover:bg-primary-50 hover:border-primary-300 hover:text-primary-700 transition-colors">
                      {c.display_name || c.name}
                    </button>
                  ))}
                </div>
              </div>

              {/* Operatorler */}
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Operatorler</label>
                <div className="flex flex-wrap gap-1">
                  {OPERATORS.map(op => (
                    <button key={op.label} onClick={() => insertToExpr(op.value)} title={op.desc}
                      className="text-xs px-2 py-1 bg-orange-50 text-orange-700 border border-orange-200 rounded hover:bg-orange-100 font-mono">
                      {op.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Fonksiyonlar */}
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">SQL Fonksiyonlari</label>
                <div className="flex flex-wrap gap-1">
                  {SQL_FUNCTIONS.map(fn => (
                    <button key={fn.label} onClick={() => insertToExpr(fn.value)} title={fn.desc}
                      className="text-[11px] px-2 py-1 bg-purple-50 text-purple-700 border border-purple-200 rounded hover:bg-purple-100">
                      {fn.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* SQL Ifadesi */}
              <div>
                <div className="flex items-center justify-between mb-1">
                  <label className="text-xs font-medium text-gray-600 flex items-center gap-1"><FiCode size={12} /> SQL Ifadesi</label>
                  <button onClick={previewExpression} className="text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">Onizle</button>
                </div>
                <textarea value={newColExpr} onChange={(e) => setNewColExpr(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg text-sm font-mono bg-gray-900 text-green-400 h-20 resize-none focus:ring-2 focus:ring-primary-500 outline-none"
                  placeholder="CARIKOD || ' - ' || UNVAN" />
                <p className="text-[10px] text-gray-400 mt-1">
                  Ornekler: CARIKOD || ' ' || UNVAN (birlestir) · CASE WHEN TUR = 'M' THEN 'Musteri' ELSE 'Tedarikci' END (kosul) · RISK * 1.18 (hesapla)
                </p>
              </div>

              {/* Onizleme sonucu */}
              {exprPreview && (
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">Onizleme Sonucu</label>
                  <div className="bg-gray-50 rounded-lg border overflow-hidden">
                    <table className="w-full text-xs">
                      <thead><tr><th className="bg-gray-100 px-3 py-1.5 text-left text-gray-500 font-medium">SONUC</th></tr></thead>
                      <tbody>
                        {exprPreview.map((row, i) => (
                          <tr key={i} className="border-t border-gray-100"><td className="px-3 py-1 text-gray-700">{row.SONUC ?? '-'}</td></tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

            <div className="px-5 py-3 border-t flex gap-2 justify-end">
              <button onClick={() => setShowAddColumn(null)} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Iptal</button>
              <button onClick={() => {
                if (!newColName || !newColExpr) { toast.error('Ad ve ifade gerekli'); return }
                toast.success(`${newColName} kolonu kaydedildi (ifade: ${newColExpr.substring(0, 30)}...)`)
                setShowAddColumn(null)
              }} className="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700">Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* Baglanti Formu Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => { setShowForm(false); setEditingSource(null) }}>
          <form onSubmit={editingSource ? updateSource : createSource} onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-semibold mb-4">{editingSource ? 'Duzenle' : 'Yeni Veri Kaynagi'}</h2>
            <div className="mb-3"><label className="block text-sm font-medium text-gray-700 mb-1">Kaynak Adi</label><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" required /></div>
            <div className="mb-3"><label className="block text-sm font-medium text-gray-700 mb-1">Tip</label><select value={form.ds_type} onChange={(e) => setForm({ ...form, ds_type: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm">{DS_TYPES.filter(t => t.value !== 'csv').map(t => <option key={t.value} value={t.value}>{t.label}</option>)}</select></div>
            <div className="grid grid-cols-2 gap-3 mb-3">
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Host</label><input value={form.host} onChange={(e) => setForm({ ...form, host: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="localhost" /></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Port</label><input value={form.port} onChange={(e) => setForm({ ...form, port: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="3050" /></div>
            </div>
            <div className="mb-3"><label className="block text-sm font-medium text-gray-700 mb-1">Veritabani</label><input value={form.database} onChange={(e) => setForm({ ...form, database: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" /></div>
            <div className="grid grid-cols-2 gap-3 mb-4">
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Kullanici</label><input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" /></div>
              <div><label className="block text-sm font-medium text-gray-700 mb-1">Sifre</label><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm" /></div>
            </div>
            <div className="flex gap-2 justify-end">
              <button type="button" onClick={() => { setShowForm(false); setEditingSource(null) }} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Iptal</button>
              <button type="submit" className="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700">{editingSource ? 'Kaydet' : 'Ekle'}</button>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}
